
import {ReactElement} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {PageDto} from "../../domain/PageDto";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {useSearchAuditRequests} from "../../application/AuditService";
import {AuditRequestSearchTerm} from "../../domain/audit/AuditRequestSearchTerm";
import AuditRequestSearchBar, {AuditRequestSearchFields} from "./AuditRequestSearchBar";
import {AuditRequest} from "../../domain/audit/AuditRequest";
import AuditRequestComponent from "../../components/AuditRequestComponent";
import {Collapse} from "@mui/material";
import {useState} from "react";

export default function AuditRequestsPage(): ReactElement {
    const searchFn: SearchDataFunction<AuditRequestSearchTerm, PageDto<AuditRequest>> = useSearchAuditRequests(null);
    const [ searchExpanded, setSearchExpanded ] = useState<boolean>(false);

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <Grid size={{ xs: 12, md: 11, lg: 11 }}>
                    <Title>Audit Requests</Title>
                </Grid>
                <AuditRequestSearchBar searchFn={ searchFn } expanded={searchExpanded} onToggle={setSearchExpanded}/>
            </Grid>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <AuditRequestSearchFields searchFn={ searchFn }/>
                    </Grid>
                </Grid>
            </Collapse>
            <Grid container spacing={2}>
                <AuditRequestComponent searchFn={ searchFn }/>
            </Grid>
        </Container>
    );
}